var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"policy",style:({ backgroundImage: `url(${require('../assets/images/grafokettbakgrundsbild2.png')})` })},[_c('div',{staticClass:"policy-document"},[(_vm.policy !== null)?_c('vue-markdown',[_vm._v(_vm._s(_vm.policy.data.policyDocument))]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }